/**
 * @desc getPoSkuBindSnDetailsInfo
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierSnSearch.getPoSkuBindSnDetailsInfo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierSn/getPoSkuBindSnDetailsInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
